import { render, staticRenderFns } from "./AdminApplicationsList.vue?vue&type=template&id=72b19ab6&scoped=true"
import script from "./AdminApplicationsList.vue?vue&type=script&lang=js"
export * from "./AdminApplicationsList.vue?vue&type=script&lang=js"
import style0 from "./AdminApplicationsList.vue?vue&type=style&index=0&id=72b19ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b19ab6",
  null
  
)

export default component.exports